import { AppConfig } from '../../shared/config/app-config';
import { LocalStorageService } from './local-storage.service';
import { ApiClientHelper } from '../helpers/api-client.helper';
import { Injectable } from '@angular/core';
import {
    AccountCreationData,
    SignupFormKey,
} from '../models/login.model';
import { Subject } from 'rxjs';
import { WizardNavigation, WizardState } from '../../kamona/model/kamonal-model';

@Injectable({
    providedIn: 'root',
})
export class OnboardingService {
    otpMessage: string;
    currentFormStep: any;
    private signUpFormData: AccountCreationData;
    private signupData = new Subject<any>();
    signupData$ = this.signupData.asObservable();
    private currentStepForm = new Subject<any>();
    currentStepForm$ = this.currentStepForm.asObservable();

    constructor(private apiClientHelper: ApiClientHelper, private localStorage: LocalStorageService, public config: AppConfig) {}

    setSignUpFormData(signUpFormData: AccountCreationData) {
        this.signUpFormData = signUpFormData;
        // this.localStorage.save('signUpFormData', JSON.stringify(signUpFormData));
    }

    setCurrentFormStep(formData) {
        this.currentFormStep = formData;
        this.currentStepForm.next(formData);
        // this.localStorage.save('currentStepForm', JSON.stringify(formData));
    }

    getCurrentFormStep() {
        // let savedSteps = this.localStorage.get('currentStepForm');
        // savedSteps = savedSteps ? JSON.parse(savedSteps) : null;
        return this.currentFormStep;
    }

    setSignupData(signupData: AccountCreationData, wizardNavigation: WizardNavigation) {
        this.signupData.next({ signupData, wizardNavigation });
        if (signupData) {
            this.setSignUpFormData(signupData);
        }
    }

    resetForm() {
        const signupData = this.getSignUpFormData();
        Object.entries(signupData).forEach(([key, value]) => {
            value[`state`] = key === SignupFormKey.PHONE_VERIFICATION ? WizardState.ACTIVE : WizardState.INACTIVE;
        });
        this.setSignupData(signupData, WizardNavigation.NEXT);
    }

    getSignUpFormData() {
        // let signUpFormData = this.localStorage.get('signUpFormData');
        // signUpFormData = signUpFormData ? JSON.parse(signUpFormData) : null;
        return this.signUpFormData;
    }

    clearSignupData() {
        this.localStorage.deleteValue('signUpFormData');
        this.localStorage.deleteValue('currentStepForm');
    }

    generateOTP(data): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/self-onboarding/verifications/phone-numbers/start`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    generateOTPV2(data): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/generate-otp`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateBVN(data): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/self-onboarding/steps/bvn`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateBVNV2(data, checkAuth = true): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/validation/bvn`;
        return this.apiClientHelper.postForPromise(url, data, checkAuth);
    }

    validBVN(bvn, checkAuth = true): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/exists/bvn/${bvn}`;
        return this.apiClientHelper.getForPromise(url, checkAuth);
    }

    validBVNV2(bvn, checkAuth = true): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/exists/bvn/${bvn}`;
        return this.apiClientHelper.getForPromise(url, checkAuth);
    }

    validateOTP(data): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/self-onboarding/verifications/phone-number/complete`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateOTPV2(data): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/validate-otp`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateEmailUniqueness(data): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/validation/email`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validatePhoneUniqueness(data): Promise<any> {
        const url = this.config.MONIEPOINT_HOST + `/api/v1/onboarding/validation/phone-number`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    onboardUserV2(data, clientType = 'WEB'): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/self-onboarding/steps/final/new`;
        return this.apiClientHelper.postForPromise(url, data, false, true, true, clientType);
    }

    onboardPosUser(data): Promise<PosOnboardingResponseModel> {
        const url = this.config.MONIEPOINT_HOST + `/api/v2/pos-request-auth/onboard`;
        return this.apiClientHelper.postForPromise(url, data, false);
    }

    validateUserName(username): Promise<any> {
        const url = this.config.MONIEPOINT_ONBOARDING + `/api/v1/uniqueness-validation/user-name`;
        return this.apiClientHelper.postForPromise(url, username, false);
    }
}

export interface PosOnboardingResponseModel {
    accountName: string;
    accountNumber: string;
    reference: string;
    balance?: number;
}
